import { type ControllingOverview, type JobCostDetail } from "@vidario/domain";
import { useQuery, type UseQueryResult } from "@tanstack/react-query";

import { useVidarioClient } from "../client";
import { queryKeys } from "../queryKeys";

/** Admin-only Controlling overview: per-job cost roll-ups + the
 * unattributed bucket. */
export function useControllingOverview(options?: {
  enabled?: boolean;
}): UseQueryResult<ControllingOverview> {
  const client = useVidarioClient();
  return useQuery({
    queryKey: queryKeys.controllingOverview(),
    queryFn: () => client.getControllingOverview(),
    enabled: options?.enabled ?? true,
  });
}

/** Admin-only Controlling detail for one job — fetched lazily when the
 * job row is expanded. */
export function useControllingJob(
  jobId: number,
  options?: { enabled?: boolean },
): UseQueryResult<JobCostDetail> {
  const client = useVidarioClient();
  return useQuery({
    queryKey: queryKeys.controllingJob(jobId),
    queryFn: () => client.getControllingJob(jobId),
    enabled: (options?.enabled ?? true) && Number.isFinite(jobId),
  });
}
